export const minimumMobileHeight = 450;

export const minimumNonMobileHeight = 600;
